<template>
  <div>
    <button
      v-if="isAuthorized"
      class="menu-entry"
      @click="isOpenedCabinetMenu = !isOpenedCabinetMenu"
    >
      <span class="menu-entry-logo"> {{ authInfo.user_first_name.charAt(0) }} </span>
      <div class="menu-entry-user">
        <span class="menu-entry-user__name">{{ authInfo.user_first_name }}</span>
        <span class="menu-entry-user__phone">{{ authInfo.user_phone_number }}</span>
      </div>
      <svg class="menu-entry__arrow" :class="{ 'menu-entry__arrow_active': isOpenedCabinetMenu }">
        <use xlink:href="#svg-arrow-right"></use>
      </svg>
    </button>
    <button v-else type="button" class="menu-entry" @click="handlerClick">
      <svg class="menu-entry__icon">
        <use xlink:href="#svg-user"></use>
      </svg>
      {{ result.name }}
    </button>
    <SlideUpDown v-model="isOpenedCabinetMenu">
      <div class="menu-mobile-cabinet">
        <a
          v-for="item in getPersonalMenu"
          class="menu-mobile-cabinet__item"
          :href="item.href"
          :class="{ 'menu-mobile-cabinet__item_active': item.active }"
        >
          <svg class="menu-mobile-cabinet__icon">
            <use v-if="item.href.match(/\/personal\/$/)" xlink:href="#svg-user"></use>
            <use
              v-else-if="item.href.includes('/personal/history/')"
              xlink:href="#svg-personal-history"
            ></use>
            <use
              v-else-if="item.href.includes('/personal/box/')"
              xlink:href="#svg-personal-box"
            ></use>
            <use
              v-else-if="item.href.includes('/personal/service/')"
              xlink:href="#svg-personal-service"
            ></use>
            <use
              v-else-if="item.href.includes('/personal/viewed/')"
              xlink:href="#svg-personal-viewed"
            ></use>
            <use
              v-else-if="item.href.includes('/personal/warranties/')"
              xlink:href="#svg-personal-warranty"
            ></use>
            <use
              v-else-if="item?.href?.match(/\/personal\/discounts\/$/)"
              xlink:href="#svg-personal-discount"
            ></use>
            <use
              v-else-if="item?.href?.match(/\/personal\/purchases\/$/)"
              xlink:href="#svg-personal-purchases"
            ></use>
            <use
              v-else-if="item?.href?.match(/\/personal\/filters\/$/)"
              xlink:href="#svg-personal-filters"
            ></use>
            <use
              v-else-if="item?.href?.match(/\/personal\/addresses\/$/)"
              xlink:href="#svg-personal-addresses"
            ></use>
            <use v-else xlink:href="#svg-log-out"></use>
          </svg>
          {{ item.name }}
        </a>
      </div>
    </SlideUpDown>
  </div>
</template>

<script setup>
import { computed, defineProps, ref } from 'vue';
import useModal from '@use/useModal/useModal';
import SignIn from '@components/Cabinet/Entry/SignIn/SignIn.vue';
import { useStore } from '@store';

const { result } = defineProps(['result']);
const { state } = useStore();
const modal = useModal();

const authInfo = computed(() => state?.personal?.data?.authInfo);
const isAuthorized = computed(() => state?.personal?.data?.authInfo?.isAuthorized);

const handlerClick = () => {
  modal.show(SignIn, {}, { width: '900px', backgroundClose: false });
};

const isOpenedCabinetMenu = ref(false);

const personalMenuMobile = computed(() => state?.results?.menus?.personalMenuMobile?.items);
const getPersonalMenu = computed(() =>
  personalMenuMobile.value.filter((el) => el?.showInMenuEntry)
);
</script>

<script>
export default {
  name: 'MenuEntry',
};
</script>

<style lang="scss" scoped>
.menu-entry {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 125%;
  cursor: pointer;
  background-color: transparent;
  padding: 16px;
  width: 100%;
  text-align: start;
  &__icon {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
  &__arrow {
    width: 20px;
    height: 20px;
    margin-left: auto;
    fill: var(--background-dark-grey);
    transition: 0.2s linear transform;
    &_active {
      transform: rotate(90deg);
    }
  }
}
.menu-entry-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  width: 32px;
  height: 32px;
  background-color: var(--background-black);
  border-radius: 50%;
  margin-right: 12px;
}
.menu-entry-user {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-row-gap: 4px;
  &__name {
    font-size: 16px;
    font-weight: 500;
    line-height: 125%; /* 20px */
  }
  &__phone {
    color: #5f5f67;
    font-size: 14px;
    font-weight: 500;
    line-height: 125%; /* 17.5px */
  }
}
.menu-mobile-cabinet {
  display: grid;
  grid-auto-rows: 48px;
  border-top: 1px solid var(--border-grey);
  &__item {
    padding: 0 16px;
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: rem(14);
    line-height: 125%;
    &_active {
      display: flex;
      align-items: center;
      background-color: var(--background-beige);
      position: relative;
    }
    &:last-child {
      color: var(--color-red);
      svg {
        fill: currentColor;
      }
    }
  }
  &__icon {
    display: block;
    margin-right: 16px;
    width: 20px;
    height: 20px;
  }
}
</style>
